import React from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton,ManText } from '@craft-design-system/core-components-react';
import ifav from './ifav.png';
import PopoverComponent from '../popover';
import { Card } from 'react-bootstrap';
import Zoom from '../Zoom';
const Yearly_mileage = ({ value }) => {
  let graphData1 = "";

  try {
    graphData1 = JSON.parse(value);
  } catch (error) {
    console.error("Error parsing JSON", error);
  }

  return (
<Card className='card_ride' >
<div className="card-title" style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px' // Ensure consistent spacing
}}>
  <div style={{
    flex: 1,
    display: 'flex',
    justifyContent: 'center', // Center text horizontally
    alignItems: 'center' // Center text vertically
  }}>
    <ManText
      className="card-title-text"
      variant="component-l"
      as="span"
      size="l"
      style={{ lineHeight: 'normal' }} // Prevent typography shifts
    >
      Yearly mileage
    </ManText>
  </div>
  <div style={{
flexShrink: 0,
display: 'flex',
alignItems: 'center', // Ensure icon aligns with text
height: '100%', // Match height to parent for consistent alignment
flexDirection:"row-reverse"
  }}>
    <PopoverComponent
      id="Yearly_mil"
      content="<b>Yearly Mileage:</b> This KPI displays the yearly driven distance of the vehicle(s).<br/><br/><b>Telematic Raw Data:</b><br/>• TBM3: payloaddecoded_totaldrivendistance_value<br/>• CM4: payload_electricmessagesystem_totaldrivendistance<br/><br/><b>Time Series Data:</b><br/>If multiple vehicles are selected average values are displayed. Days without data are not taken into account for the calculation.<br/><br/>For the current year a <b>linear extrapolation</b> of the previous data provides an estimate for the annual mileage at the end of the year."
      style={{ verticalAlign: 'middle' }} // Ensure icon alignment
    />
        <Zoom
    chartData={graphData1?.data}
    chartLayout={graphData1?.layout}
    chartTitle="Yearly mileage
    "
  />
  </div>
</div>
    
      <Plot 
        data={graphData1.data} 
        layout={{
            ...graphData1.layout,
            autosize: true,
            responsive: true,
            margin: { t: 10, r: 10, l: 50, b: 200 }
        }}
        useResizeHandler={true}
    />
    </Card>
  );
};

Yearly_mileage.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Yearly_mileage;
